// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\DefaultImage\ApiDefaultImage.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DefaultImageType } from 'server/enums/DefaultImageType';

// DefaultImageData is the class that DefaultImage serializes to/from
export interface DefaultImageData {
    Id : number;
	
    ProfileUrl : string | null;
    ThumbUrl : string | null;
	
    Order : number;
    Type : DefaultImageType;
}

// DefaultImageOptions is the class which may be passed to the DefaultImage constructor to define optional initial data values
export interface DefaultImageOptions {
    Id : number;
	
    ProfileUrl? : string | null;
    ThumbUrl? : string | null;
	
    Order? : number;
    Type? : DefaultImageType;
}

export class DefaultImage {
    public Id : DataSignal<number>;
	
    public ProfileUrl : DataSignal<string | null>;
    public ThumbUrl : DataSignal<string | null>;
	
    public Order : DataSignal<number>;
    public Type : DataSignal<DefaultImageType>;

    constructor();
    constructor(data : DefaultImageOptions);
    constructor(data: DefaultImageOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ProfileUrl = jsonableObservable(S.value<string | null>(data && data.ProfileUrl !== undefined ? data.ProfileUrl : null));
        this.ThumbUrl = jsonableObservable(S.value<string | null>(data && data.ThumbUrl !== undefined ? data.ThumbUrl : null));
	    
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
        this.Type = jsonableObservable(S.value<DefaultImageType>(data && data.Type !== undefined ? data.Type : 0));
    }

    static key(obj : DefaultImage) {
        return obj.Id();
    }
    
    static dataKey(obj : DefaultImageOptions) {
        return obj.Id;
    }

    static update(obj : DefaultImage, data : DefaultImageOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ProfileUrl !== undefined) obj.ProfileUrl(data.ProfileUrl);
            if (data.ThumbUrl !== undefined) obj.ThumbUrl(data.ThumbUrl);
	        
            if (data.Order !== undefined) obj.Order(data.Order);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DefaultImage.ts